import React, { Component } from "react";

// import logo1 from 'assets/images/logo/switzerland.png';
// import logo2 from 'assets/images/logo/eurail.png';

import i18n from "i18n-react";
import { BackImage } from "C4";
import logo from "assets/images/logo/logo_caymankind.png";
import { HashLink as Link } from "react-router-hash-link";

export default class RewardsView extends Component {
  render() {
    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }

    return (
      <div className="contentContainer BookingForm">
        <BackImage />
        <div className="header">
          <Link to="/main">
            <img src={logo} alt="Logo" className="logo" />
          </Link>
          <h3>{i18n.translate("rewards.bookingForm.title")}</h3>
        </div>
        <hr />
        <div className="bodyRewardsTerms">
          <h1>TERMS & CONDITIONS</h1>
          <p>
            Cayman Islands Rewards Programme is not a sweepstakes. Cayman
            Rewards is a performance-based rewards program. Participation is
            strictly limited to enrolled travel advisors who meet all criteria
            set forth by the operators/administrators/facilitators, Cayman
            Islands Department of Tourism. TravPro Mobile LLC is a vendor
            supporting the program with products and services.
            <br />
            <br />
            <b>MONTHLY GRAND PRIZE</b>
            <br />
            $500 for the travel advisor booking the highest number of guests to
            the Cayman Islands.
            <br />
            <br />
            <b>MONTHLY FIRST RUNNER-UP</b>
            <br />
            $250 for the travel advisor booking the next-highest number of
            guests to the Cayman Islands.
            <br />
            <br />
            <b>MONTHLY SECOND RUNNER-UP</b>
            <br />
            $100 for the travel advisor booking the next-highest number of
            guests to the Cayman Islands.
            <br />
            <br />
            <b>1 MONTHLY RANDOMLY CHOSEN WINNER</b>
            <br />
            $100 for one randomly selected travel advisor with qualifying
            bookings of guests to the Cayman Islands.
            <br />
            <br />
            *Bookings entered are valid only after client&apos;s travel is
            completed.
            <br />
            <br />
            <b>PARTICIPATION</b>
            <br />
            Participation in the Cayman Rewards program is open to all U.S. and
            Canadian travel advisors operating under a current and legitimate
            ARC/IATA or CLIA number, except where those travel advisors are or
            act as wholesalers. To qualify, bookings must include overnight
            accommodations in the Cayman Islands. Cruise bookings do not qualify
            for awards. Winners must be at least 18 years of age and legal
            residents of the U.S. or Canada. Winners will be notified on a
            monthly basis. Monthly cash awards will be processed via ACH direct
            deposit within 3 to 5 weeks after the confirmation of winning travel
            advisors each month. Winning travel advisors are responsible for all
            federal, state, provincial and local taxes on any awards received.
            Enrollment, activation and/or re-enrollment are the sole
            responsibility of participating travel advisors. Travel advisors who
            change agencies during the course of the Cayman Rewards program may
            not transfer bookings to a new agency, but may re-enroll with their
            new agency, provided the new agency enrolls or is already enrolled
            in the program. Agencies may not combine bookings of multiple travel
            advisors into an individual travel advisor account. Cayman Islands
            Department of Tourism (CIDOT) reserves the right to verify bookings
            at any time without notice, and/or to refuse award(s) based on
            non-compliance with program rules. CIDOT reserves the right at any
            time at its absolute discretion to refuse or revoke membership in
            the program for any reason. It is the sole responsibility of
            participating travel advisors to confirm receipt of program
            bookings. CIDOT and TravPro Mobile LLC are not responsible for lost,
            late, misdirected, or incomplete entries, interrupted or unavailable
            network, server or other connections or miscommunications. CIDOT is
            solely accountable for the Cayman Rewards program. TravPro Mobile
            LLC is not responsible or liable for the verification of
            information, the distribution of prizes, nor any portion of their
            value. Void where prohibited or restricted by law. Other conditions
            may apply. Participants agree to the above terms and conditions and
            accept the decisions of CIDOT as final. Any persons providing false
            information forfeit all awards and prizes associated with program
            and may risk prosecution under applicable law. Rules are subject to
            change without notice. Canadian winners are rewarded in Canadian
            dollars.
            <br />
            <br />
            Limit, three first place prizes in a calendar year; upon winning the
            third first place prize, travel advisors are excluded from winning
            first prize for the balance of the calendar year.
          </p>
          <hr />
          <div className="buttonHolder">
            {mobile && (
              <Link to="/main/rewards?mobile=true">
                <button type="button" className="btn">
                  Return to landing &gt;
                </button>
              </Link>
            )}
            {!mobile && (
              <Link to="/main/rewards">
                <button type="button" className="btn">
                  Return to landing &gt;
                </button>
              </Link>
            )}
          </div>
        </div>
        {mobile && (
          <style>
            {
              "\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }"
            }
          </style>
        )}
      </div>
    );
  }
}
